import { Module } from 'vuex';
import { RootState } from '../types';
import { AuthState } from './types';

import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

import { User } from '@/models';

/**
 * Default state
 */
export const state: AuthState = {
  user: new User(),
  cognitoUser: null,
};

/**
 * Use namespaced Vuex modules
 */
const namespaced: boolean = true;

/**
 * Module export
 */
const auth: Module<AuthState, RootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced,
};

export default auth;
